import { AfterViewInit, Component, ElementRef } from '@angular/core';

@Component({
  selector: 'screen-row',
  templateUrl: './row.component.html',
  styleUrls: ['./row.component.less']
})
export class SimpleRowComponent implements AfterViewInit {
  constructor(private _elementRef: ElementRef) {
  }

  ngAfterViewInit() {
  }
}
